import { createSlice } from '@reduxjs/toolkit';
import { getAdminSession, loginAdminUser } from './adminAuth.actions';

const initialState = {
  isLoadingAdminLogin: false,

  adminSession: false,
  adminData: {},
  isLoadingAdminSession: false,
};

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    setAdminData: (state, action) => {
      state.adminData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginAdminUser.pending, (state) => {
      state.isLoadingAdminLogin = true;
    });
    builder.addCase(loginAdminUser.fulfilled, (state) => {
      state.isLoadingAdminLogin = false;
    });
    builder.addCase(loginAdminUser.rejected, (state) => {
      state.isLoadingAdminLogin = false;
    });

    builder.addCase(getAdminSession.pending, (state) => {
      state.isLoadingAdminSession = true;
    });
    builder.addCase(getAdminSession.fulfilled, (state, action) => {
      state.adminSession = action.payload;
      state.isLoadingAdminSession = false;
    });
    builder.addCase(getAdminSession.rejected, (state) => {
      state.isLoadingAdminSession = false;
    });
  },
});

export const { setAdminData } = adminAuthSlice.actions;

export default adminAuthSlice.reducer;
